import { render, staticRenderFns } from "./StatsKpiCellData.vue?vue&type=template&id=04431318&scoped=true&"
import script from "./StatsKpiCellData.vue?vue&type=script&lang=js&"
export * from "./StatsKpiCellData.vue?vue&type=script&lang=js&"
import style0 from "./StatsKpiCellData.vue?vue&type=style&index=0&id=04431318&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04431318",
  null
  
)

export default component.exports